import { render, staticRenderFns } from "./MerchantRequests.vue?vue&type=template&id=f256051e&scoped=true&"
import script from "./MerchantRequests.vue?vue&type=script&lang=js&"
export * from "./MerchantRequests.vue?vue&type=script&lang=js&"
import style0 from "./MerchantRequests.vue?vue&type=style&index=0&id=f256051e&scoped=true&lang=css&"
import style1 from "./MerchantRequests.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f256051e",
  null
  
)

export default component.exports